import {store} from '..';
import { call, put } from 'redux-saga/effects';
import { url } from '../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';

const updateNotificationsAPI = (value) => {

    return APICallingService.sendRequestForPut(value, url.edittNotifications, (res) => {

    }, true);
}

function* updateNotification(action) {
    try {
        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(updateNotificationsAPI, action.payload.value);
        if (response && response?.callBackStatus.toLowerCase() == 'success') {
            alert('Notifaction Read Successfully');

            yield put({
                type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.EDIT_NOTIFICATIONS_API_SUCCESS, payload: { value: response?.callBackStatus }
            });
            yield put({
                type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.GET_NOTIFICATIONS_API_CALL
            });
        }
        else {
            if (response && response != null && response.Status != 405) {

                yield put({
                    type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.EDIT_NOTIFICATIONS_API_SUCCESS, payload: { value: response?.callBackStatus }
                });
                alert('Failed to update notifaction');
            }
        }
    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.EDIT_NOTIFICATIONS_API_SUCCESS, payload: { value: 'Failed' } });
    }
}

const getNotificationAPI = () => {

    let urlNotification = url.getNotifications;
    return APICallingService.sendRequestForGet(urlNotification, (res) => {

    }, true);
}

function* getNotification(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(getNotificationAPI);
        if (response && response != null) {
            yield put({
                type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.GET_NOTIFICATIONS_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {

                alert('Failed to get notification');
                yield put({
                    type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.GET_NOTIFICATIONS_API_SUCCESS, payload: { value: response.data }
                });
            }
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.GET_NOTIFICATIONS_API_SUCCESS, payload: { value: 'Failed' }
        })
    }
}


export { updateNotification, getNotification };
